module.exports = __webpack_public_path__ + "img/icon-community.18ffa29d.png";